import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import _ from 'lodash';

class SubdomainRedirect extends Component {
  constructor( props ){
    super();
    this.state = { ...props };
  }
  
  render() {
    // return (<section>Redirecting...</section>);
    return (
      <Fragment>
        { _.startsWith(window.location.hostname, this.props.subdomain) ? (
          <Fragment>
          <section>Redirecting...</section>
          <Route path="/" exact render={() => (
            // <Redirect to={this.props.to} />
            <Fragment>
              {window.location = this.state.to}
            </Fragment>
          )} />
          </Fragment>
        ) : null }
      </Fragment>
    )
  }
}

class App extends Component {

  render() {
    return (
      <Router>
        <div>
          <SubdomainRedirect subdomain="customer" to="/dashboard/" />
          <SubdomainRedirect subdomain="portal" to="/dashboard/" />
          <SubdomainRedirect subdomain="hq" to="/dashboard/" />
          <SubdomainRedirect subdomain="candidate" to="/hub/" />
          <SubdomainRedirect subdomain="my" to="/hub/" />
          <SubdomainRedirect subdomain="hub" to="/hub/" />
          <SubdomainRedirect subdomain="sso" to="/auth/" />
          <SubdomainRedirect subdomain="ops" to="/landing/" />
          <SubdomainRedirect subdomain="localhost" to="/testing/" />
          <SubdomainRedirect subdomain="docs" to="/components/" />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js